// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__formContent--L57OX {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__listHeader--tjpoa {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__listTitle--h93PF {
  flex: 1;
}
.src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__listContent--Yf4hC {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__listItem--FNMIu {
  display: grid;
  gap: 8px;
  grid-template-columns: 80px 1fr 36px;
}
.src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__thumb--_WwYl {
  height: 100%;
  background: #eee;
  display: flex;
  justify-content: center;
  align-items: center;
}
.src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__badImage--fAotD {
  color: #e9033a;
  font-size: 48px;
}
.src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__img--UCwf8 {
  max-width: 100%;
  max-height: 100%;
}
/*# sourceMappingURL=ExternalImagesModal.module.css.map */`, "",{"version":3,"sources":["webpack://./ExternalImagesModal.module.less","webpack://./src/business/attribute/attrEdits/AttrExternalImages/ExternalImagesModal.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;ACCF;ADEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;ACAF;ADEA;EACE,OAAA;ACAF;ADGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACDF;ADIA;EACE,aAAA;EACA,QAAA;EACA,oCAAA;ACFF;ADKA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACHF;ADMA;EACE,cAAA;EACA,eAAA;ACJF;ADOA;EACE,eAAA;EACA,gBAAA;ACLF;AACA,yDAAyD","sourcesContent":[".formContent {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.listHeader {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n}\n.listTitle {\n  flex: 1;\n}\n\n.listContent {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.listItem {\n  display: grid;\n  gap: 8px;\n  grid-template-columns: 80px 1fr 36px;\n}\n\n.thumb {\n  height: 100%;\n  background: #eee;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.badImage {\n  color: #e9033a;\n  font-size: 48px;\n}\n\n.img {\n  max-width: 100%;\n  max-height: 100%;\n}\n",".formContent {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.listHeader {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n}\n.listTitle {\n  flex: 1;\n}\n.listContent {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.listItem {\n  display: grid;\n  gap: 8px;\n  grid-template-columns: 80px 1fr 36px;\n}\n.thumb {\n  height: 100%;\n  background: #eee;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.badImage {\n  color: #e9033a;\n  font-size: 48px;\n}\n.img {\n  max-width: 100%;\n  max-height: 100%;\n}\n/*# sourceMappingURL=ExternalImagesModal.module.css.map */"],"sourceRoot":""}]);
// Exports
export var formContent = `src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__formContent--L57OX`;
export var listHeader = `src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__listHeader--tjpoa`;
export var listTitle = `src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__listTitle--h93PF`;
export var listContent = `src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__listContent--Yf4hC`;
export var listItem = `src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__listItem--FNMIu`;
export var thumb = `src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__thumb--_WwYl`;
export var badImage = `src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__badImage--fAotD`;
export var img = `src-business-attribute-attrEdits-AttrExternalImages-ExternalImagesModal-module__img--UCwf8`;
export default ___CSS_LOADER_EXPORT___;
